var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrandmother(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8H17C18.6569 8 20 9.34315 20 11C20 12.6569 18.6569 14 17 14H8C6.34315 14 5 12.6569 5 11C5 9.34315 6.34315 8 8 8Z",
    fill: "#E6E5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 14.4945C14.7271 14.4945 17.1 12.1216 17.1 9.19453C17.1 6.26742 14.7271 3.89453 11.8 3.89453C8.87289 3.89453 6.5 6.26742 6.5 9.19453C6.5 12.1216 8.87289 14.4945 11.8 14.4945Z",
    fill: "#D2D1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4255 2.65094C14.6321 2.24264 13.4236 2 10.9616 2C8.49957 2 6.49953 2.49985 5.99957 3.99985C5.4996 5.49985 7.36653 6.49985 8.99957 6.49985C10.6327 6.49985 11.4996 6.49985 12.9456 5.99984C14.3917 5.49984 14.835 6.65208 14.835 7.3048C14.835 7.95752 14.835 7.80799 14.835 7.80799C14.835 8.99742 15.2476 9.77532 15.4995 9.99985C15.9955 10.4419 16.5558 10.4318 17.5182 9.99985C18.0035 9.78202 17.9996 8.42665 17.9996 8.04778C17.9996 7.74414 17.9674 5.99728 17.5184 5.02389C16.9936 3.88601 16.3115 3.10686 15.4255 2.65094Z",
    fill: "#E6E5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90955 16.4263C5.81207 15.513 7.03614 15 8.3125 15H15.1875C16.4639 15 17.6879 15.513 18.5905 16.4263C19.493 17.3395 20 18.5781 20 19.8696V21.6087C20 22.3771 19.3844 23 18.625 23C18.0625 23 5.43748 23 4.875 23C4.11561 23 3.5 22.3771 3.5 21.6087V19.8696C3.5 18.5781 4.00703 17.3395 4.90955 16.4263Z",
    fill: "url(#paint0_linear_25516_37875)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78684 10.3079C8.35075 10.3079 8.80789 9.85075 8.80789 9.28684C8.80789 8.72293 8.35075 8.26579 7.78684 8.26579C7.22293 8.26579 6.76579 8.72293 6.76579 9.28684C6.76579 9.85075 7.22293 10.3079 7.78684 10.3079ZM9.5692 9.41447C9.50376 10.3418 8.73077 11.0737 7.78684 11.0737C6.8 11.0737 6 10.2737 6 9.28684C6 8.3 6.8 7.5 7.78684 7.5C8.54885 7.5 9.19945 7.97699 9.45636 8.64868H10.4516C10.7085 7.97699 11.3591 7.5 12.1211 7.5C12.7374 7.5 13.2809 7.81207 13.6021 8.28683H16.25H16.3975V8.29449C17.1035 8.36819 17.6539 8.96521 17.6539 9.69078C17.6539 10.4662 17.0254 11.0947 16.25 11.0947V10.3289C16.6024 10.3289 16.8882 10.0432 16.8882 9.69078C16.8882 9.33834 16.6024 9.05262 16.25 9.05262H13.8927C13.9027 9.12927 13.9079 9.20745 13.9079 9.28684C13.9079 10.2737 13.1079 11.0737 12.1211 11.0737C11.1771 11.0737 10.4042 10.3418 10.3387 9.41447L9.5692 9.41447ZM12.1211 10.3079C12.685 10.3079 13.1421 9.85075 13.1421 9.28684C13.1421 8.72293 12.685 8.26579 12.1211 8.26579C11.5572 8.26579 11.1 8.72293 11.1 9.28684C11.1 9.85075 11.5572 10.3079 12.1211 10.3079Z",
    fill: "#7C7DE3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25516_37875",
    x1: 13.0014,
    y1: 13.8883,
    x2: 5.8518,
    y2: 25.1253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484275,
    stopColor: "#A3A2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#8F8DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8DEF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrandmother);
export default __webpack_public_path__ + "static/media/grandmother.161097a775c9435305e71720e9f2ec53.svg";
export { ForwardRef as ReactComponent };